import xhrService from '../xhrService';
import {
  ReopenInspectionApi,
  SignatureGroupType,
} from '@stormwater-software/lib-certification';
import db from '../../db/db';

export const inspectionQuestionReopeningLogApi: ReopenInspectionApi = {
  update: async (inspectionId: number) => {
    if (navigator.onLine) {
      return xhrService
        .post(`/api/inspections/${inspectionId}/open`)
        .then((res) => res.data)
        .catch(({ response }) => {
          throw new Error(response.data.message);
        });
    } else {
      const existingCertification = await db.certifications
        .get(inspectionId)
        .catch((error: any) => {
          console.log(
            'Error getting offline inspe  ction certifications',
            error,
          );

          Promise.reject(error);
        });

      existingCertification.userSignatures[SignatureGroupType.compliance] = [];
      existingCertification.sync.payload = existingCertification.sync.payload.filter(
        (item: any) => item.group !== 'compliance',
      );
    

      db.inspections.update(inspectionId, { compliance_date: '' });
      db.certifications.update(inspectionId, existingCertification);

      return db.inspections
        .get(inspectionId)
        .then((result) => {
          return { inspection: result };
        })
        .catch(({ response }) => {
          throw new Error(response.data.message);
        });
    }
  },
};

export default inspectionQuestionReopeningLogApi;
